module.exports = __webpack_public_path__ + "static/media/patient_female.916f8e04.png";